import ReactDOM from "react-dom";
import { useState } from "react";
import e from "../style.module.css";
import { useLocation } from 'wouter';

import { Irecovery } from "../Recovery.models";

import Button from "components/common/Button/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputGroup } from "react-bootstrap";

function ModalElem({ onSubmit, disableBtn }: Irecovery) {
  const [validated, setValidated] = useState(false);
  const [, setLocation] = useLocation();
  
  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    
    if (form.checkValidity()) {
      onSubmit(event.target[0].value);
    }
    setValidated(true);
  };

  return (
    <>
      <Modal
        show={true}
        backdrop="static"
        dialogClassName="modal-md"
        keyboard={false}
        animation={false}
        centered
      >
        <Modal.Body className="p-2 py-lg-3 px-lg-4">
          <Container>
            <Row>
              <Col
                xs={12}
                className={`order-lg-1 ${e["login__panel-button"]}`}
              >
                <div className="d-flex align-items-center">
                  <button className="btn btn-link ps-0 "><i onClick={() => setLocation('/login')} className="bi bi-arrow-left"></i></button>
                  <h5 className="m-0">Recuperar cuenta</h5>
                </div>

                <p>Ingresa el nombre de usuario registrado a su cuenta.</p>
                <Form className={`mt-2 not-valid-flags ${e.login__form}`}  noValidate validated={validated} onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="validationUser">
                    <Form.Label>Nombre de usuario</Form.Label>
                    <InputGroup hasValidation>
                      <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Usuario"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Este campo es requerido.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <div className="d-flex justify-content-end mt-5">
                    <Button
                      type="submit"
                      className={`mb-3 ${e.modal__btn}`}
                      value="Enviar correo"
                      onClick={() => onSubmit}
                      disabled={disableBtn}
                      showLoading={true}
                    />
                  </div>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export const ModalRecovery = ({ onSubmit, disableBtn}: Irecovery) => {
  const modalRoot = document.getElementById("modal-root") as HTMLElement;
  return ReactDOM.createPortal(
    <ModalElem
      onSubmit={onSubmit}
      disableBtn={disableBtn}
    />,
    modalRoot
  );
};

